<template>
  <div class="firemanage-page" v-loading.fullscreen.lock="loadingCB" :element-loading-text="loadingCText">
    <div class="password" v-if="showPassWord">
      <div class="elbut">
        <el-form :model="ruleForm" status-icon @submit.native.prevent :rules="rules" ref="ruleForm">
          <el-form-item prop="password">
            <el-input style="width: 72%" placeholder="请输入密码解锁键盘" :disabled="detail.deviceId ? false : true"
              v-model="ruleForm.password" @keyup.native.enter="untie" show-password>
            </el-input>
            <el-button @click="untie" :disabled="detail.deviceId ? false : true" :loading="passwordLoading"
              type="primary">
              {{ passwordLoading ? "解锁中" : "解锁" }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-container>
      <div style="position: relative" class="container-left" v-loading="loadingC" :element-loading-text="loadingCText">
        <!-- 操作按钮 -->
        <div style="text-align: right; margin: 12px 12px 0">
          <el-button type="primary" v-if="!switchFj" :disabled="!handleType" @click="handleType = false"
            icon="el-icon-s-help">一键操作</el-button>
          <el-button type="primary" @click="handleType = true" :disabled="handleType"
            icon="el-icon-thumb">单键操作</el-button>
        </div>
        <el-scrollbar class="scrollbar">
          <div class="page-left">
            <div class="leftTop" v-show="handleType">
              <!-- 物联网 -->
              <fireIndex2 v-if="controlType == 2" ref="controlDevice"
                :deviceName="selectDeviceData.relationDeviceName || detail.deviceName" :detail="detail"
                @controlCallBack="controlCallBack">
              </fireIndex2>
              <!-- new 键盘 -->
              <component :is="showTypeComponent(controlType)" ref="controlDevice" :deviceVersion="!detail.subDeviceMark
                ? detail.deviceVersion
                : detail.parentDeviceVersion
                " :deviceName="detail.subDeviceMark ? detail.parentThirdDeviceName : detail.deviceName
    " :fireType="$route.query.alarmType" @controlCallBack="controlCallBack"></component>
            </div>
            <div v-show="!handleType" class="leftTop">
              <!-- 一键操作 -->
              <div class="handlePage">
                <div style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <div class="title">操作类型</div>
                  <el-button type="info" v-if="!handleType" @click="handleTabsEdit('', 'add')"
                    icon="el-icon-plus">添加类型</el-button>
                </div>
                <el-scrollbar style="height: 167px">
                  <!-- 类型list -->
                  <div class="handletab">
                    <div v-for="(item, index) in handleList" :class="[
                      'handTabItem',
                      'successItem' + index,
                      'errorItem' + index,
                      activeName == index ? 'activeItem' : '',
                    ]" :title="item.operationConfigTypeName" @click="handleClickTab(index)"
                      :key="item.operationConfigTypeCode">
                      <span>{{ item.operationConfigTypeName }}</span>
                      <span class="icon">
                        <i class="el-icon-edit" title="编辑" @click.stop="handleTabsEdit(index, 'edit')"></i>
                        <i class="el-icon-delete" title="删除" @click.stop="handleTabsEdit(index, 'remove')"></i>
                      </span>
                    </div>
                    <div class="noData" v-if="handleList.length === 0">
                      <!-- <div class="text-center" style="margin-bottom: 10px">
                      <img src="@/common/assets/images/empty.svg" class="no-data_img" />
                    </div> -->
                      暂无操作类型
                    </div>
                  </div>
                </el-scrollbar>
                <!-- 分页器 -->
                <el-pagination class="mt10" background v-if="handleList.length > 41" layout="total, prev, pager, next"
                  @current-change="handleCurrentTypeChange" :page-size="handleListPage.pageSize"
                  :total="handleListPage.total" :pager-count="handleListPage.countPage || 11"
                  :current-page="handleListPage.pageNum" />

                <!-- 步骤list -->
                <div class="handStepInfo">
                  <div style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      margin-bottom: 12px;
                    ">
                    <div class="title">操作步骤</div>
                    <div>
                      <el-button type="info" @click="addStep" v-if="handleList.length"
                        icon="el-icon-plus">添加步骤</el-button>
                    </div>
                  </div>
                  <el-scrollbar style="height: 100%; overflow-y: auto; overflow-x: none" v-if="handleItem.length > 0">
                    <el-timeline style="margin: 16px" class="timeLine">
                      <el-timeline-item :timestamp="'步骤名称：' + item.stepName" placement="top"
                        v-for="(item, index) in handleItem" :class="activeStep > index
                          ? 'active'
                          : activeStep == index
                            ? 'activeing'
                            : ''
                          " :key="index">
                        <div class="step-row">
                          <i class="el-icon-edit" @click="editStep(item, index)"></i>
                          <i class="el-icon-delete" @click="deleteStep(item, index)"></i>
                        </div>
                        <div class="step-cord">
                          <p>
                            操作类型：{{
                              item.operationKeyType == 2 ? "固定输入" : "键盘输入"
                            }}
                          </p>
                          <p>内容：{{ item.inputContentStr }}</p>
                        </div>
                      </el-timeline-item>
                    </el-timeline>
                  </el-scrollbar>
                  <div v-else class="bg" style="height: 54px">
                    <div class="noData">暂无操作步骤</div>
                  </div>
                  <div style="margin-top: 12px">
                    <span v-if="handleItem.length">
                      <el-button type="primary" v-if="!isAction" style="padding: 5px 10px" @click="actionStep"
                        icon="el-icon-s-help">开始操作</el-button>
                      <el-button type="primary" v-if="isAction && activeStep != handleItem.length"
                        @click="handleStep(activeName)" style="padding: 5px 10px">下一步</el-button>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 风机水泵list -->
            <div class="pagefjDevice">
              <div class="fjTitle">
                关联风机数据
                <div>
                  <el-button type="primary" style="padding: 5px 15px" v-if="switchFj" @click="handleBack">取消</el-button>
                  <el-button type="info" @click="handleAdd" icon="el-icon-plus">添加风机</el-button>
                </div>
              </div>
              <el-scrollbar style="margin-bottom: 10x">
                <div class="handleDevices">
                  <div v-for="(item, index) in deviceFjList"
                    :class="['handDeviceItem', activeDevice == index ? 'activeItem' : '']"
                    :title="item.relationDeviceName" @click="handleClickDevice(index)" :key="item.operationConfigCode">
                    <i :title="item.relationDeviceName" class="icon iconfont-lunan"
                      :class="['icon-lunan-SENU087' + (item.relationDeviceType || 28)]"></i>
                    <div class="deviceContent">{{ item.relationDeviceName }}</div>
                    <i class="el-icon-close iconClose" title="解除关联" @click.stop="handleDeviceEdit(index, 'remove')"></i>
                  </div>
                  <div class="noData" v-if="deviceFjList.length === 0">
                    <!-- <div class="text-center" style="margin-bottom: 10px">
                    <img src="@/common/assets/images/empty.svg" class="no-data_img" />
                  </div> -->
                    暂无风机数据
                  </div>
                </div>
              </el-scrollbar>
            </div>
            <!-- 设备信息 -->
            <div class="left-deviceInfo" v-if="detail.deviceId">
              <div class="deviceInfo-main">
                <div class="deviceTitle">
                  <span>设备信息</span>
                  <el-button style="margin-left: 6px; font-size: 16px" type="text" @click="isExpand = !isExpand"
                    :title="isExpand ? '关闭' : '打开'" :class="[
                      'iconfont-lunan icon-lunan-xiaosanjiaodown',
                      isExpand ? 'icon-transform' : '',
                    ]">
                  </el-button>
                </div>
                <!-- <transition name="el-zoom-in-top"> -->
                <fire-device-info v-show="isExpand" :detail="detail" />
                <!-- </transition> -->
              </div>
              <div class="deviceBtn" style="margin-bottom: 20px" v-if="alarmFire.length">
                <el-button type="primary" @click="goBackT">确认处理</el-button>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>

      <!-- <div class="right-box" style="flex: 1" v-loading="!showPlayBox" element-loading-text="插件加载中...">
        <div style="display: flex; justify-content: space-between; margin: 10px 10px 0">
          <el-button type="info" @click="addCamera" icon="iconfont icon-xinzeng">添加摄像机</el-button>
          <el-button type="primary" @click="goBack" icon="iconfont icon-iconfontfanhui">返回上一页</el-button>
        </div>
        <VideojsPlayerNew v-if="showPlayBox" ref="player"
          style="height: calc(100% - 10px); color: #fff; margin-left: 0px"></VideojsPlayerNew>
      </div> -->

      <div class="right-box" style="flex: 1">
        <div style="display: flex; justify-content: space-between; margin: 10px 10px 0">
          <el-button type="info" @click="addCamera" icon="iconfont icon-xinzeng">添加摄像机</el-button>
          <el-button type="primary" @click="goBack" icon="iconfont icon-iconfontfanhui">返回上一页</el-button>
        </div>
        <div style="height: calc(100% - 50px); margin-top: 10px;">
          <DhPlayer ref="dhPlayerFire" videoId="dhPlayerFire"
            :shieldClass="['el-message', 'el-message-box', 'el-dialog', 'el-picker-panel', 'hover-blur-panel', 'app-side-panel']"
            :windowType="windowType" :division="division"></DhPlayer>
        </div>
      </div>
    </el-container>
    <!-- 摄像机弹窗 -->

    <app-panel title="选择摄像机" :isExpand="dialogVisible" @cancel="cancelDialog">
      <DeviceTree ref="cameraTree" :isPageTree="true" :expandAll="false" :ajaxOption="ajaxOption"
        :deviceOption="deviceOption" :showCheckbox="true" style="height: 100%; overflow: hidden" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取消</el-button>
        <el-button type="primary" @click="submitDialog">确定</el-button>
      </span>
    </app-panel>

    <el-dialog title="操作提示" :visible.sync="dialogDevice" v-dialogDrag width="450px">
      <span>是否执行【
        {{ "按键：" + deviceText }}
        <!-- {{ checkControlCode.controlCodeTypeName }} -->
        <!-- {{ deviceKey | dic("SENU098") }}  -->
        】操作？
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialogDevice = false"> 取消</el-button>
        <el-button type="primary" @click="sendControl">确定</el-button>
      </span>
    </el-dialog>
    <!-- 键盘弹窗 -->
    <app-panel title="键盘输入" :isExpand="dialogShow" @cancel="dialogShow = false">
      <!-- <el-dialog
      title="键盘输入"
      v-ops:width="680"
      :visible.sync="dialogShow"
      @close="dialogShow = false"
      :close-on-click-modal="false"
    > -->
      <el-scrollbar style="height: 100%">
        <!-- 物联网 -->
        <fireIndex2 v-if="controlType == 2" ref="dialogControlDevice" :detail="detail"
          :deviceName="selectDeviceData.relationDeviceName || detail.deviceName" @controlCallBack="controlCallBack" />
        <!-- new 键盘 -->
        <component :is="showTypeComponent(controlType)" ref="dialogControlDevice" :deviceVersion="!detail.subDeviceMark ? detail.deviceVersion : detail.parentDeviceVersion
          " :deviceName="detail.subDeviceMark ? detail.parentThirdDeviceName : detail.deviceName
    " :fireType="$route.query.alarmType" @controlCallBack="controlCallBack"></component>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="overDialog">结 束</el-button>
      </span>
      <!-- </el-dialog> -->
    </app-panel>

    <!-- 新增类型弹窗 -->
    <el-dialog :title="dialogTitle" v-dialogDrag width="400px" class="choose-box" :before-close="cancleForm"
      :visible.sync="dialogConfigType">
      <el-form :model="configForm" :rules="rules" ref="configForm" label-width="100px">
        <el-form-item label="类型名称" prop="name" label-width="80px">
          <el-input v-model="configForm.name" autocomplete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleForm">取消</el-button>
        <el-button type="primary" @click="confirmForm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 消防设备弹窗 -->
    <el-dialog title="风机设备" width="1020px" :before-close="cancleFireDevice" :visible.sync="dialogFireDevice">
      <ioc-table style="height: 400px" ref="multipleTable" :data="tableDataDevice" :option="deviceOptions"
        :page="devicePage" @size-change="personChangeSize" @search-reset="handleSearchReset"
        @search-change="handleSearchChange" @selection-change="handeleSelect" @current-change="currentChange">
      </ioc-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancleFireDevice">取消</el-button>
        <el-button type="primary" @click="confirmFireDevice">确认</el-button>
      </span>
    </el-dialog>
    <!-- 新增/修改键盘内容 -->
    <add-config-dialog ref="addDialog" :state="state" :controlType="controlType"
      :deviceId="switchFj ? selectDeviceData.relationDeviceId : hostId" :detail="detail" :stepInfo="stepInfo"
      @refresh="getFireActionList(type.operationConfigTypeCode)"></add-config-dialog>
  </div>
</template>
<script>
import sha256 from "js-sha256";
import { Dic } from "$utils";
import { api } from "../api";
import utils from "@src/common/utils";
import appPanel from "@src/components/business/app-panel/index.vue";
import DeviceTree from "@src/components/business/app-device-tree";
// import VideojsPlayerNew from "@src/modules/videoMonitoring/components/player-box.vue";
import DhPlayer from "@/components/business/dh-player/index.vue"
import fireIndex2 from "../components/fireTemplate/index2"; //物联网
import fireIndexGst from "../components/fireTemplate/GTS500"; //Gst5000
import fireIndexGstH from "../components/fireTemplate/GTS15000H"; //Gst5000H
import GST200 from "../components/fireTemplate/GTS200-2"; //GST200

import fireDeviceInfo from "../components/fireDeviceInfo"; //deviceInfo
import { deviceOptions } from "../const/operation";
import addConfigDialog from "@src/modules/cameraList/components/addConfigDialog";
export default {
  watch: {
    handleType(val) {
      // false是一键操作，true是单键操作
      if (val == false) {
        this.activeName = "0";
        this.handleList.length &&
          this.getFireActionList(this.handleList[0].operationConfigTypeCode);
      } else {
        this.$nextTick(() => {
          this.$refs.controlDevice.changeBgColor(this.isSuccess, this.clickBtnList);
        });
        // this.$refs.controlDevice.changeBgColor(this.isSuccess, this.deviceKey);
        if (this.controlType == 2) {
          // 物联网
          this.$nextTick(() => {
            // this.$refs.controlDevice.changeBgColor(
            //   this.isSuccess,
            //   this.deviceKey
            // );
            this.$refs.controlDevice.getControlCodeOption();
          });
        }
      }
      this.activeStep = -1;
      this.isAction = false;
    },
  },
  computed: {
    isInitPlay() {
      return this.$store.getters.isInitPlay;
    },
  },
  components: {
    appPanel,
    DeviceTree,
    // VideojsPlayerNew,
    DhPlayer,
    fireIndex2,
    fireDeviceInfo,
    // new 键盘
    GST200,
    fireIndexGst,
    fireIndexGstH,
    addConfigDialog,
  },

  data() {
    return {
      showPlayBox: false,
      ajaxOption: {
        api: "/bms/device/queryDeviceWorkGroupDeviceTree.json",
        params: {
          deviceType: 10,
        },
      },
      deviceOption: {
        icon: "iconfont-lunan icon-lunan-shexiangtou",
        nodeType: "device",
        key: "id",
      },
      successName: "",
      errorName: "",
      isExpand: false,
      switchFj: false,
      deviceFjList: [],
      activeDevice: "-1",
      devicePage: {
        pageNum: 1,
        total: 0,
        alarmType: [],
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      deviceOptions: deviceOptions(),
      tableDataDevice: [],
      selectDevice: [],
      dialogFireDevice: false,
      dialogTitle: "新增类型",
      configForm: {
        name: "",
        code: "",
      },
      type: {},
      dialogConfigType: false,
      dialogShow: false,
      operationKeyType: "", //1.键盘输入，2固定输入
      isAction: false,
      // handleList: Dic.find('SENU099'),
      handleList: [],
      handleListPage: {
        pageSize: 42,
        pageNum: 1,
        total: 0,
      },
      handleItem: [],
      activeName: "",
      activeStep: -1,
      handleType: false,
      deviceVersion: "",
      deviceName: "",
      fireType: "",
      dialogDevice: false,
      deviceKey: "", //按键值
      deviceText: "", //按键名称
      passwordLoading: false,
      isOpen: false,
      loadingC: false,
      loadingCB: false,
      loadingCText: "加载中",
      detail: {},
      rules: {
        password: [
          {
            required: true,
            message: "请输入正确的密码,解锁键盘",
            trigger: ["change", "blur"],
          },
        ],
        name: [
          { required: true, message: "请输入类型名称", trigger: "blur" },
          {
            // min: 1,
            // max: 10,
            message: "请输入类型名称",
            trigger: "blur",
          },
        ],
      },
      ruleForm: {
        password: "",
      },
      controlType: "", //海湾CGS200  GTS200-1   GTS500 GTS500-1 2.物联网  北大JBF11FS-1  JBF11FS-2
      screenSet: false,
      showPassWord: true,
      dialogVisible: false,
      isGetResult: false,
      orderList: [], //一键操作指令list
      orderIndex: -1,
      timeData: null,
      alarmFire: [],
      selectDeviceData: {},
      state: 1, // 1: 新增 2：修改
      stepInfo: {},
      hostId: "", //主机id
      controlCodeOption: Dic.find("SENU095001"),
      checkControlCode: {},
      backType: "2",
      isSuccess: true,
      clickBtnList: [],
      btnIndex: "", //键盘按钮索引值
      // dh视频插件
      // 播放类型
      windowType: 0,
      // 分割窗格
      division: 4,
      // 当前窗口
      currentNum: 0,
      firstIp: ''
    };
  },
  created() {
    let hostName = location.hostname;
    let ipIndex = hostName.indexOf('.')
    if (ipIndex !== -1) {
      this.firstIp = hostName.substring(0, ipIndex)
    }
    this.alarmFire =
      (this.$route.query.alarmFire && this.$route.query.alarmFire.split("-")) || [];
    this.getDeviceDetail(this.$route.query.id);
  },
  mounted() {
    this.$refs["cameraTree"].openDialog();
    setTimeout(() => {
      this.showPlayBox = true;
      // this.$nextTick(() => {
      //   this.$refs.player.handleChangeScreen(4);
      // });
      setTimeout(() => {
        this.getDeviceVideo(this.$route.query.id);
      }, 5000);
    }, 1500);
  },
  beforeDestroy() {
    this.$refs.dhPlayerFire.closeVideo()
    this.$refs.dhPlayerFire.destroy()
  },
  methods: {
    randomData() {
      return Math.random(Math.random() * 100)
    },
    // 判断使用何种键盘
    showTypeComponent(val) {
      if (val == "GST5000") {
        return "fireIndexGst";
      } else if (val == "GST5000H") {
        return "fireIndexGstH";
      } else if (val == "GST200") {
        return "GST200";
      }
      // if (val == "GST500" || val == "GST5000" || val == "GST1500H") {
      //   return "fireIndexGst";
      // } else if (val == "GST200") {
      //   return "fireIndexGstT";
      // } else if (val == "GST200-2") {
      //   return "fireIndexGstTS";
      // } else if (val == "GST5000H") {
      //   return "fireIndexGstH";
      // } else if (val == "JBF-11SF-H" || val == "JBF-11SF" || val == "JBF-11SF-S") {
      //   return "fireIndexJbf";
      // }
    },
    // 类型分页
    handleCurrentTypeChange(val) {
      this.handleListPage.pageNum = val;
      this.getConfigTypeList(true);
    },
    // 新增步骤
    addStep() {
      this.stepInfo = {};
      this.state = 1;
      this.$nextTick(() => {
        this.$refs.addDialog.open(this.type.operationConfigTypeCode);
      });
    },
    // 修改步骤内容
    editStep(data) {
      this.stepInfo = data;
      this.state = 2;
      this.$nextTick(() => {
        this.$refs.addDialog.open(this.type.operationConfigTypeCode);
      });
    },

    // 删除步骤
    deleteStep(data) {
      let params = {
        operationConfigCode: data.operationConfigCode,
      };
      this.$confirm("确定对步骤【" + data.stepName + "】执行删除操作？", "操作确认", {
        type: "warning",
      })
        .then((res) => {
          this.$fetch(api.deleteConfigStep, params).then((res) => {
            if (res.success) {
              this.getFireActionList(this.type.operationConfigTypeCode);
              this.$message.success(res.msgContent || "删除成功 ");
            } else {
              this.$message.error(res.msgContent || "删除失败");
            }
          });
        })
        .catch((e) => { });
    },
    handleSearchReset() {
      this.devicePage.parentDeviceName = "";
      this.devicePage.pageNum = 1;
      this.devicePage.pageSize = 10;
      this.getFireDeviceList();
    },
    handleSearchChange(param) {
      this.devicePage.parentDeviceName = param.parentDeviceName;
      this.getFireDeviceList();
    },
    personChangeSize(val) {
      this.devicePage.pageNum = 1;
      this.devicePage.pageSize = val;
      this.getFireDeviceList();
    },
    // 风机水泵选中回调
    handeleSelect(data) {
      this.selectDevice = [...data];
    },
    currentChange(val) {
      this.devicePage.pageNum = val;
      this.getFireDeviceList();
    },
    cancleFireDevice() {
      this.selectDevice = [];
      this.dialogFireDevice = false;
    },
    // 关联风机水泵确认回调
    confirmFireDevice() {
      this.dialogFireDevice = false;
      // this.deviceFjList = [...this.selectDevice]
      this.$fetch(api.addDeviceRelationDevice, {
        deviceId: this.hostId, // this.$route.query.id,
        relationDeviceIdList: this.selectDevice.map((el) => {
          return el.deviceId;
        }),
      }).then((res) => {
        if (res.success) {
          this.selectDevice.map((item) => {
            this.deviceFjList.push({
              deviceId: this.$route.query.id,
              relationDeviceId: item.deviceId,
              relationDeviceName: item.parentDeviceName,
            });
          });
          // this.activeDevice = Number(this.deviceFjList.length - 1).toString()
          this.$message.success(res.msgContent || "关联成功 ");
        } else {
          this.$message.error(res.msgContent || "关联失败");
        }
      });
    },
    // 切换为主机键盘，单建是1，一键是2
    handleBack() {
      if (this.backType == 2) {
        // 返回到一键操作
        this.handleType = true;
      } else {
        // 返回到单键操作
        this.handleType = false;
      }
      this.switchPageType(this.$route.query.id);
      this.activeDevice = "-1";
      this.switchFj = false;
      this.getConfigTypeList(true);
    },
    // 关联风机水泵
    handleAdd() {
      this.getFireDeviceList();
      this.dialogFireDevice = true;
      // 选中回显
      this.$nextTick(() => {
        this.$refs.multipleTable.$refs.multipleTable.clearSelection();
      });
    },
    // 新增/编辑类型
    confirmForm() {
      this.$refs.configForm.validate((valid) => {
        if (valid) {
          let params = {
            deviceId: this.switchFj
              ? this.selectDeviceData.relationDeviceId
              : this.hostId,
            operationConfigTypeName: this.configForm.name,
          };
          let url = api.addConfigTypeList;
          if (this.dialogTitle == "编辑类型") {
            params.operationConfigTypeCode = this.configForm.code;
            url = api.updateConfigTypeList;
          }
          this.$fetch(url, params).then((res) => {
            if (res && res.success) {
              this.getConfigTypeList();
              this.$message.success(res.msgContent || "操作成功");
              this.$refs.configForm.resetFields();
              this.dialogConfigType = false;
            } else {
              this.$message.error(res.msgContent || "操作失败");
            }
          });
        }
      });
    },
    cancleForm() {
      this.$refs.configForm.resetFields();
      this.dialogConfigType = false;
    },
    // 切换键盘专用
    switchPageType(deviceId) {
      // this.controlCodeOption = []
      this.$fetch(api.fire.getDeviceDetail, { deviceId: deviceId }).then((res) => {
        if (res.success) {
          let detail = res.returnObj.deviceInfo;
          this.detail = res.returnObj.deviceInfo;
          // console.log(this.detail)
          if (detail.deviceType == "27") {
            if (detail.subDeviceMark) {
              if (detail.parentFactoryId == 1) {
                this.controlType = Dic.findByValue(
                  "SENU095",
                  this.detail.parentDeviceVersion
                );
              } else {
                // 默认显示海湾
                this.controlType = Dic.findByValue(
                  "SENU095",
                  this.detail.parentDeviceVersion
                );
                // this.controlType = 1
              }
            } else {
              // 主机
              if (detail.factoryId == 1) {
                // this.controlType = 5
                this.controlType = Dic.findByValue("SENU095", this.detail.deviceVersion);
              } else {
                this.controlType = Dic.findByValue("SENU095", this.detail.deviceVersion);
                // this.controlType = 1
              }
            }
          } else {
            this.controlType = 2;
            this.$nextTick(() => {
              // if (this.detail.controlMode == "1")
              this.$refs.controlDevice.getControlCodeOption();
            });
          }
        } else {
          this.$message.error(res.msgContent || "查询数据失败");
        }
      });
    },
    // 点击风机水泵
    handleClickDevice(val) {
      // console.log(val)
      // console.log(this.deviceFjList)
      this.activeDevice = val;
      this.switchFj = true;
      this.selectDeviceData = this.deviceFjList[val];
      // this.$refs.controlDevice.getControlCodeOption()
      this.switchPageType(this.selectDeviceData.relationDeviceId);
      // this.getConfigTypeList(true);
      this.$nextTick(() => {
        if (this.handleType == false) {
          // 切换为单键模式
          this.handleType = true;
          this.backType = 1;
        } else {
          this.backType = 2;
        }
      });
    },
    handleDeviceEdit(targetName, action) {
      if (action === "remove") {
        this.$confirm(
          "确定对风机【" +
          this.deviceFjList[targetName].relationDeviceName +
          "】解除关联？",
          "操作确认",
          {
            type: "warning",
          }
        )
          .then((res) => {
            this.$fetch(api.deleteDeviceRelationDevice, {
              deviceId: this.hostId, //this.$route.query.id,
              relationDeviceId: this.deviceFjList[targetName].relationDeviceId,
            }).then((res) => {
              if (res.success) {
                this.deviceFjList.splice(targetName, 1);
                if (this.activeDevice == targetName) {
                  this.activeDevice =
                    targetName - 1 == -1 ? "0" : (targetName - 1).toString();
                  this.handleClickDevice(this.activeDevice);
                }
                // this.getConfigTypeList()
                this.$message.success(res.msgContent || "解除关联成功 ");
              } else {
                this.$message.error(res.msgContent || "解除关联失败");
              }
            });
          })
          .catch((e) => { });
      }
    },
    handleTabsEdit(targetName, action) {
      // 新增操作
      if (action === "add") {
        this.dialogTitle = "新增类型";
        this.dialogConfigType = true;
      }
      // 编辑操作
      if (action === "edit") {
        this.dialogTitle = "编辑类型";
        this.dialogConfigType = true;
        this.configForm.name = this.handleList[targetName].operationConfigTypeName;
        this.configForm.code = this.handleList[targetName].operationConfigTypeCode;
      }
      // 删除操作
      if (action === "remove") {
        this.$confirm(
          "确定对类型【" +
          this.handleList[targetName].operationConfigTypeName +
          "】执行删除操作？",
          "操作确认",
          {
            type: "warning",
          }
        )
          .then((res) => {
            this.$fetch(api.deleteConfigTypeList, {
              deviceId: this.switchFj
                ? this.selectDeviceData.relationDeviceId
                : this.hostId,
              operationConfigTypeCode: this.handleList[targetName]
                .operationConfigTypeCode,
            }).then((res) => {
              if (res.success) {
                this.activeName =
                  targetName - 1 == -1 ? "0" : (targetName - 1).toString();
                this.getConfigTypeList();
                this.$message.success(res.msgContent || "删除成功 ");
              } else {
                this.$message.error(res.msgContent || "删除失败");
              }
            });
          })
          .catch((e) => { });
      }
    },
    // 获取模块类型配置
    getConfigTypeList(isFirst = false) {
      let params = {
        deviceId: this.switchFj ? this.selectDeviceData.relationDeviceId : this.hostId,
        pageNum: this.handleListPage.pageNum,
        pageSize: this.handleListPage.pageSize,
      };
      this.$fetch(api.queryConfigTypeList, params).then((res) => {
        if (res && res.success) {
          this.handleList = res.returnObj.list || [];
          this.type = res.returnObj.list[0];
          this.handleListPage.total = res.returnObj ? res.returnObj.total : 0;
          if (isFirst) {
            this.activeName = "0";
            this.handleList.length &&
              this.getFireActionList(this.handleList[0].operationConfigTypeCode);
          }
        } else {
          this.$message.error(res.msgContent || "获取数据失败");
        }
      });
    },
    // 获取消防设备
    getFireDeviceList() {
      let params = {
        pageNum: this.devicePage.pageNum,
        pageSize: this.devicePage.pageSize,
        deviceId: this.$route.query.id,
        deviceMarkList: ["28", "29"],
        parentDeviceName: this.devicePage.parentDeviceName,
        buildingCode: this.detail.parentBuildingCode,
        systemId: 200000024,
      };
      this.$fetch(api.fire.queryFireDeviceList, params).then((res) => {
        if (res && res.success) {
          this.tableDataDevice = res.returnObj.list;
          this.devicePage.total = res.returnObj ? res.returnObj.total : 0;
        } else {
          this.$message.error(res.msgContent || "获取数据失败");
        }
      });
    },
    // 结束键盘输入并进入下一步
    overDialog() {
      this.dialogShow = false;
      this.activeStep += 1;
    },
    getFireActionList(type) {
      let parsms = {
        deviceId: this.switchFj ? this.selectDeviceData.relationDeviceId : this.hostId,
        operationConfigType: type,
      };
      this.isAction = false;
      this.activeStep = -1;
      this.$fetch(api.fire.queryFireFightingOperationConfigList, parsms).then((res) => {
        // 步骤详情
        if (res && res.success) {
          // this.activeName = type.toString()
          this.handleItem = [];
          if (res.returnObj.length) {
            let data = res.returnObj;
            // data.forEach((el) => {
            //   el.text = el.inputContent
            //     .split(";")
            //     .map((el) => {
            //       return Dic.findByValue("SENU098", el);
            //     })
            //     .join(",");
            // });
            this.handleItem = [].concat([...data]);
          }
        } else {
          res.msgContent && this.$message.error(res.msgContent);
        }
      });
    },
    // 一键操作开始
    actionStep() {
      this.isAction = true;
      this.activeStep = 0;
    },
    // 发送指令
    sendStep(index) {
      this.isGetResult = false;
      let params = {
        deviceId: this.switchFj
          ? this.selectDeviceData.relationDeviceId
          : this.$route.query.id,
        cmdKey: this.orderList[this.orderIndex],
        needUnLockFlag: this.switchFj ? 0 : 1,
        operateType: this.handleType ? 1 : 2, //1：单键操作，2：一键操作
      };
      this.$fetch(api.fire.controlFirefighting, params).then((res) => {
        if (res && res.success) {
          this.timeData = setTimeout(() => {
            if (!this.isGetResult) {
              this.isGetResult = true;
              this.$alert("按钮响应超时,请进行复位操作 !", "提示", {
                confirmButtonText: "确定",
                type: "warning",
                showClose: false,
                callback: (action) => {
                  this.loadingC = false;
                },
              });
              if (index) {
                let errorDiv = document.getElementsByClassName("errorItem" + index)[0];

                errorDiv.style.border = "1px dashed red";
                errorDiv.style.color = "red";
              }
            } else {
              if (index) {
                let successDiv = document.getElementsByClassName("successsItem" + index);
                successDiv.style.border = "1px dashed green";
                successDiv.style.color = "green";
              }
            }
          }, 10000);
          this.getResult(res.returnObj);
        } else {
          res.msgContent && this.$message.error(res.msgContent);
          this.orderIndex = -1;
          this.loadingC = false;
        }
      });
    },
    // 下一步按钮
    handleStep(index) {
      // 发送指令 operationKeyType
      let stepData = this.handleItem[this.activeStep];
      this.operationKeyType = stepData.operationKeyType;
      this.orderIndex = 0;
      // console.log(this.operationKeyType)
      if (stepData.operationKeyType == 1) {
        // 键盘输入 弹出键盘
        if (this.controlType == 2) {
          this.$refs.dialogControlDevice.getControlCodeOption();
        }
        this.dialogShow = true;
      } else {
        this.orderList = stepData.inputContent.split(";");
        this.orderList.pop();
        this.sendStep(index);
        this.loadingCText = "等待操作响应";
        this.loadingC = true;
      }
    },
    // 展示节点下的步骤详情
    handleClickTab(val) {
      this.activeName = val;
      this.type = this.handleList[Number(val)];
      this.getFireActionList(this.type.operationConfigTypeCode);
    },
    getDeviceDetail(data) {
      this.loadingCText = "加载中";
      this.loadingC = true;
      this.$fetch(api.fire.getDeviceDetail, { deviceId: data }).then((res) => {
        setTimeout(() => {
          this.loadingC = false;
        }, 1000);
        if (res && res.success) {
          let detail = res.returnObj.deviceInfo;
          if (!detail) {
            this.$message.warning("暂无设备信息");
            return;
          }
          this.detail = res.returnObj.deviceInfo;
          this.hostId = this.detail.subDeviceMark
            ? this.detail.parentDeviceId
            : this.detail.deviceId;
          this.getConfigTypeList(true);
          this.deviceFjList = res.returnObj.deviceInfo.deviceRelationDeviceList || [];
          if (this.detail.deviceType == "27") {
            // controlType 海湾CGS200  GTS200-1   GTS500 GTS500-1 2.物联网  北大JBF11FS-1  JBF11FS-2
            // FactoryId 1北大  2海湾 -1未知
            if (this.detail.subDeviceMark) {
              // Dic.findByValue('SENU095', res.returnObj)
              // 部件parentDeviceVersion/deviceVersion
              if (this.detail.parentFactoryId == 1) {
                this.controlType = Dic.findByValue(
                  "SENU095",
                  this.detail.parentDeviceVersion
                );
              } else {
                // 默认显示海湾
                this.controlType = Dic.findByValue(
                  "SENU095",
                  this.detail.parentDeviceVersion
                );
                // this.controlType = 1
              }
            } else {
              // 主机
              if (this.detail.factoryId == 1) {
                // this.controlType = 5
                this.controlType = Dic.findByValue("SENU095", this.detail.deviceVersion);
              } else {
                this.controlType = Dic.findByValue("SENU095", this.detail.deviceVersion);
                // this.controlType = 1
              }
            }
          } else {
            // let arr = [];
            // if (this.detail.controlCodeList) {
            //   this.controlCodeOption.forEach((item) => {
            //     this.detail.controlCodeList.forEach((items) => {
            //       if (item.value == items) {
            //         arr.push(item)
            //       }
            //     })
            //   })
            // }
            // this.controlCodeOption = arr
            this.controlType = 2;
          }
        } else {
          this.$message.error("获取设备详情失败");
        }
      });
    },
    // 播放主机配置的视频信息
    getDeviceVideo(val) {
      this.loadingCText = "加载中";
      this.loadingC = true;
      this.$fetch(api.fire.getDeviceVideo, {
        deviceId: val,
        cameraConfigFlag: "0",
      }).then((res) => {
        this.loadingC = false;
        if (res && res.success) {
          let deviceList = res.returnObj;
          if (deviceList.length) {
            let windowNumber =
              deviceList.length < 5
                ? 4
                : deviceList.length < 9 && deviceList.length > 4
                  ? 9
                  : 16;
            // this.$refs.player.windowNumber = windowNumber;
            // this.$refs.player.handleChangeScreen(windowNumber);
            this.division = windowNumber
            this.currentNum = 0
            deviceList.forEach((el, index) => {
              if (el.thirdCameraId) {
                // this.$refs.player.handlePlayLive(
                //   {
                //     thirdCameraId: el.thirdCameraId,
                //     name: el.cameraName,
                //   },
                //   index + 1
                // );
                this.queryVideoRtsp(el)
              }
            });
          } else {
            // this.$refs.player.handleChangeScreen(4);
            this.division = 4
          }
        } else {
          // this.$refs.player.handleChangeScreen(4);
          this.division = 4
        }
      });
    },
    // 获取直播url并播放
    queryVideoRtsp(option) {
      const param = {
        deviceIdList: [option.thirdCameraId],
        protocol: 'rtsp'
      }
      this.$fetch(api.queryRealTimeVideoRtsp, param).then(res => {
        if (res.success) {
          let inNetUrl = res.returnObj[0].url.substring(0, res.returnObj[0].url.indexOf('|'))
          let outNetUrl = res.returnObj[0].url.substr(res.returnObj[0].url.indexOf('|') + 1, res.returnObj[0].url.length)
          // console.log('内网', inNetUrl)
          // console.log('外网', outNetUrl)
          let rtspUrl = ''
          if (this.firstIp == '10' || this.firstIp == '172' || this.firstIp == '192') {
            rtspUrl = inNetUrl
          } else {
            rtspUrl = outNetUrl
          }
          let rtspObj = {
            channelId: res.returnObj[0].deviceId,
            path: rtspUrl,
            cameraType: res.returnObj[0].cameraType
          }
          this.realByUrl(rtspObj)
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
    // 通过rtsp流播放实时预览
    realByUrl(deviceInfo) {
      let param = {
        channelId: deviceInfo.channelId,  // 通道ID,必传
        path: deviceInfo.path,  // 流地址
        redirect: false, // 9090端口为true   9100端口为false 必传
        cameraType: deviceInfo.cameraType
      }
      // console.log(param, '播放参数')
      this.$refs.dhPlayerFire.realByUrl(param, this.currentNum) // 播放的窗口序号 (从0开始计数，表示第一个窗口)
      this.currentNum = this.currentNum + 1
    },
    // 获取指令处理结果
    getResult(val) {
      let params = {
        recordCode: val,
      };
      this.$fetch(api.fire.queryFirefightingControlReply, params).then((res) => {
        if (this.orderIndex != -1) {
          // 一键操作的逻辑
          if (res && res.success) {
            if (res.returnObj == -1) {
              // 10s继续调用
              setTimeout(() => {
                !this.isGetResult ? this.getResult(val) : "";
              }, 2000);
            } else {
              clearTimeout(this.timeData);
              this.isGetResult = true;
              if (
                this.operationKeyType == 2 &&
                this.orderIndex < this.orderList.length - 1
              ) {
                this.orderIndex += 1;
                this.sendStep();
                return false;
              }
              if (res.returnObj.replySign == 3) {
                // 3
                this.$message.success(
                  "执行结果:成功" // + Dic.findByValue("SENU096", res.returnObj)
                );
              } else {
                // 6
                this.$message.error("执行结果:失败, 失败原因：" + res.returnObj.errorMsg); //，+ Dic.findByValue("SENU096", res.returnObj));
              }
              // this.$message.success("操作成功");
              this.loadingC = false;
              this.loadingCB = false;
              if (this.operationKeyType == 2) {
                this.activeStep += 1;
                this.orderIndex = -1;
              }
            }
          } else {
            res.msgContent && this.$message.error(res.msgContent);
          }
          return false;
        }
        if (res && res.success) {
          if (res.returnObj == -1) {
            // 10s继续调用
            setTimeout(() => {
              !this.isGetResult ? this.getResult(val) : "";
            }, 2000);
          } else {
            this.isGetResult = true;
            if (res.returnObj.replySign == 3) {
              // 3
              this.$message.success(
                "执行结果:成功" // + Dic.findByValue("SENU096", res.returnObj)
              );
            } else {
              // 6
              this.$message.error("执行结果:失败;  失败原因：" + res.returnObj.errorMsg); //，+ Dic.findByValue("SENU096", res.returnObj));
            }
            this.$refs.controlDevice.respondText =
              this.$refs.controlDevice.respondText +
              " ; " +
              " 执行结果：【" +
              Dic.findByValue("SENU096", res.returnObj.replySign) +
              "】\n" +
              (res.returnObj.replySign == 6 ? "原因：" + res.returnObj.errorMsg : "");
            this.showPassWord = false;
            this.loadingC = false;
            this.loadingCB = false;
            this.dialogDevice = false;
          }
        } else {
          res.msgContent && this.$message.error(res.msgContent);
        }
      });
    },
    // 确定发送指令
    sendControl() {
      console.log("发送指令", this.deviceKey);
      this.clickBtnList.push(this.deviceKey);
      this.isGetResult = false;
      this.$refs.controlDevice.respondText = "执行【 按键：" + this.deviceText + "】";
      this.dialogDevice = false;
      this.loadingCText = "等待操作响应";
      if (this.operationKeyType == 1) {
        this.loadingCB = true;
      } else {
        this.loadingC = true;
      }
      let params = {
        // deviceId: this.detail.parentDeviceId || this.detail.deviceId,		//--主机id
        deviceId: this.switchFj
          ? this.selectDeviceData.relationDeviceId
          : this.$route.query.id, //--传递id
        cmdKey: this.deviceKey,
        needUnLockFlag: this.switchFj ? 0 : 1,
        operateType: this.handleType ? 1 : 2, //1：单键操作，2：一键操作
      };
      // if (this.controlType == 2) {
      //   // 多风机模式
      //   params.controlCode = this.checkControlCode.controlCodeTypeCode;
      // }
      this.$fetch(api.fire.controlFirefighting, params).then((res) => {
        if (res && res.success) {
          // this.showPassWord = false
          // 开始查询控制回调
          this.getResult(res.returnObj);
          setTimeout(() => {
            if (!this.isGetResult) {
              this.isGetResult = true;
              this.$alert("按钮响应超时,请进行复位操作 !", "提示", {
                confirmButtonText: "确定",
                type: "warning",
                showClose: false,
                callback: (action) => {
                  this.$refs.controlDevice.respondText =
                    this.$refs.controlDevice.respondText +
                    " / " +
                    " 执行结果：【操作响应失败】";
                  this.showPassWord = false;
                  this.loadingC = false;
                  this.clickBtnList.forEach((item) => {
                    // console.log(item, this.$refs.controlDevice, "66666666666");
                    // let divItem =
                    //   this.$refs.controlDevice.document.getElementsByName(item);
                    // divItem.style.background = "red";
                  });
                  this.isSuccess = false;
                  this.loadingCB = false;
                  this.dialogDevice = false;
                  this.btnIndex || this.btnIndex === 0
                    ? this.$refs.controlDevice.changeBgColor(
                      this.isSuccess,
                      this.clickBtnList,
                      this.btnIndex
                    )
                    : this.$refs.controlDevice.changeBgColor(
                      this.isSuccess,
                      this.clickBtnList
                    );
                },
              });
            } else {
              // console.log("成功111111111111111111");
              this.isSuccess = true;
              this.btnIndex
                ? this.$refs.controlDevice.changeBgColor(
                  this.isSuccess,
                  this.clickBtnList,
                  this.btnIndex
                )
                : this.$refs.controlDevice.changeBgColor(
                  this.isSuccess,
                  this.clickBtnList
                );
            }
          }, 10000);
        } else {
          res.msgContent && this.$message.error(res.msgContent);
          this.loadingCB = false;
          this.loadingC = false;
          this.dialogDevice = false;
        }
      });
    },
    // text-按键名称 value:按键值
    controlCallBack(text, value) {
      // if (index || index === 0) this.btnIndex = index;
      this.deviceKey = value;
      this.deviceText = text;
      // item ? (this.checkControlCode = item) : (this.checkControlCode = {});
      this.$refs.controlDevice.respondText = "";
      this.dialogDevice = true;
      // this.clickBtnList.push(val);
    },
    submitDialog() {
      let node = this.$refs.cameraTree.$refs.dialogTree.getCheckedNodes();
      let checkDevice = node.filter((item) => {
        return item.nodeType == "device";
      });
      if (checkDevice.length > 0) {
        if (checkDevice.length > 16) {
          this.$message.warning("请注意：最多一次播放16路摄像机");
          return;
        }
        this.cancelDialog();

        // let playRecord = this.$refs.player.playRecord; //所有窗口集合
        // let deviceRecord = this.$refs.player.deviceRecord; //已播放的集合
        // let allNum = Object.keys(deviceRecord).length + checkDevice.length;
        // // 设置最优窗口数
        // if (allNum > this.$refs.player.windowNumber) {
        //   let windowNumber = allNum < 5 ? 4 : allNum < 9 && allNum > 4 ? 9 : 16;
        //   this.$refs.player.handleChangeScreen(windowNumber);
        // }
        // let activeWnd = this.$refs.player.activeWnd; // 当前正在播放的位置

        // // checkDevice.forEach((item, index) => {

        // // 剩余窗口位置
        // let newIndex = [];
        // for (let i = activeWnd; i < 17; i++) {
        //   if (!playRecord[`wnd_${i}`]) {
        //     newIndex.push(i);
        //   }
        // }
        // // 剩余窗口位置不满足，则开始替换窗口
        // if (newIndex.length < checkDevice.length) {
        //   for (let t = 1; t <= 16 - newIndex.length; t++) {
        //     newIndex.push(t);
        //   }
        // }
        this.division = checkDevice.length
        this.currentNum = 0
        checkDevice.forEach((el, index) => {
          // this.$refs.player.handlePlayLive(
          //   {
          //     thirdCameraId: el.thirdCameraId,
          //     name: el.name,
          //   },
          //   newIndex[index]
          // );
          this.queryVideoRtsp(el)
        });
      } else {
        this.$message.warning("请选择摄像机设备");
      }
    },
    cancelDialog() {
      this.dialogVisible = false;
      this.$refs.cameraTree.$refs.dialogTree.setCheckedKeys([]);
    },
    addCamera() {
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },
    stopAll() {
      // this.$refs.player.handleStopAllVideo();
      this.$refs.dhPlayerFire.closeVideo()
    },
    // 解密
    untie() {
      this.$refs.ruleForm.validate((vaild) => {
        if (vaild) {
          this.passwordLoading = true;
          let password = sha256(this.ruleForm.password);
          let params = {
            deviceId: this.detail.subDeviceMark
              ? this.detail.parentDeviceId
              : this.detail.deviceId, //--主机id
            unlockPassword: password,
          };
          this.$fetch(api.fire.checkPassword, params).then((res) => {
            if (res && res.success) {
              this.showPassWord = false;
              this.$message.success("解锁成功");
            } else {
              res.msgContent && this.$message.error(res.msgContent);
            }
            setTimeout(() => {
              this.passwordLoading = false;
            }, 500);
          });
        }
      });
    },
    updateAlarm() {
      let params = {
        alarmId: this.alarmFire[0],
        alarmState: this.alarmFire[1],
        processDesc: "消防键盘已处理确认",
      };
      this.$fetch(api.alarm.updateAlarm, params).then((response) => {
        if (response && response.success) {
          this.goBack();
        }
      });
    },
    goBackT() {
      this.$alert("确定后键盘进入锁屏状态且返回上一页,确定结束所有操作?", "提示", {
        confirmButtonText: "确定",
        callback: (action) => {
          // console.log(action)
          if (action == "confirm") {
            this.updateAlarm();
          }
        },
      });
    },
    goBack() {
      this.stopAll();
      this.$router.push("/security/home");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.firemanage-page {
  margin: 0 16px;
  width: 100%;
  height: 100%;
  position: relative;

  .deviceInfo {
    @include set_theme_color(background-color, menu-tab-bg-color);
  }

  .bg {
    @include set_theme_color(background-color, menu-tab-bg-color);
  }

  .noData {
    margin: 20px auto;
    font-size: 14px;
  }

  .title {
    text-align: left;
    font-size: 15px;
  }

  .password {
    position: absolute;
    width: 700px;
    height: 100vh;
    background: #4b5566;
    z-index: 3;
    opacity: 0.9;
    display: block;
  }

  .current {
    display: none;
  }

  .elbut {
    position: absolute;
    z-index: 2;
    width: 60%;
    top: 30%;
    border-radius: 5px;
    padding: 15px;
    @include set_theme_color(background-color, blur-color);
    left: calc(50% - 210px);
  }

  .timeLine {
    :deep .el-timeline-item {
      .el-timeline-item__node {
        box-shadow: 0px 0px 5px 4px #407aee;
      }

      .el-timeline-item__timestamp {
        text-align: left;
        font-size: 15px;
        color: #c3d3f5;
      }

      &.active {
        .el-timeline-item__timestamp {
          color: #67c23a;
        }

        .el-timeline-item__node {
          box-shadow: 0px 0px 5px 4px #67c23a;
        }
      }

      &.activeing {
        .el-timeline-item__timestamp {
          //color: #ffffff;
        }
      }

      &:hover {
        .step-row {
          display: block;
        }
      }
    }

    .el-timeline-item__content {
      // color: #ffffff;

      p {
        margin: 12px 0;
      }

      .action {
        position: absolute;
        top: -12px;
        right: 0;
        color: #fff;
        background: #407aee;
        padding: 4px 8px;
        border-radius: 5px;
      }
    }

    :deep .step-row {
      display: none;
      color: #fff;
      width: 65px;
      position: absolute;
      top: 3px;
      right: 0;
      margin-left: 10px;

      i {
        font-size: 18px;
        margin-right: 12px;
        cursor: pointer;

        &:hover {
          @include set_theme_color(color, active-border-color);
        }
      }
    }

    .step-cord {
      padding: 2px;
      color: #c3d3f5;
      border: none;
      background-color: #0d121c;
    }
  }

  .el-container {
    height: 100%;
    width: 100%;

    .container-left {
      @include set_theme_color(background-color, left-menu-bg-color);
    }

    .scrollbar {
      // margin-bottom: 15x;
      width: 700px;
      height: calc(100% - 55px);
    }

    .page-left {
      display: flex;
      flex-wrap: wrap;
      // @include set_theme_color(background-color, left-menu-bg-color);
      // width: 40% !important;
      width: 700px !important;
      height: 100%;
      text-align: center;
      line-height: 100%;
      position: initial;
      padding: 12px;

      .leftTop {
        width: 100%;
        padding-bottom: 12px;

        .handlePage {
          .handletab {
            margin: 12px 0;
            width: 100%;
            // max-height: 318px;
            // min-height: 150px;
            flex-flow: wrap;
            display: flex;
            @include set_theme_color(background-color, menu-tab-bg-color);

            // justify-content: center;
            .activeItem {
              .icon {
                display: grid !important;
                color: #fff;
              }

              @include set_theme_color(color, active-border-color);
              @include set_theme_color(border-color, active-border-color);
            }

            .handTabItem {
              cursor: pointer;
              width: 88px;
              border: 1px dashed #fff;
              margin: 4px;
              height: 45px;
              text-align: center;
              line-height: 45px;
              word-break: break-all;
              text-overflow: ellipsis;
              overflow: hidden;
              position: relative;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;

              &:hover {
                @include set_theme_color(border-color, active-border-color);

                .icon {
                  display: grid;
                  color: #fff;
                }
              }

              .icon {
                @include set_theme_color(background-color, main-theme-color);
                display: flow-root;
                right: -12px;
                position: absolute;
                top: 0px;
                width: 35px;
                display: grid;
                height: 100%;
                display: none;
                padding-top: 5px;
                padding-right: 10px;
                border-radius: 50%;
              }
            }
          }

          .handStepInfo {
            // height: 60%;
            margin: 12px 0;
            max-height: 400px;
            display: flex;
            flex-direction: column;

            .handStep {
              width: 100%;
              max-height: 160px;
              // margin: 10px;
              display: inline-flex !important;
              align-items: center;
              display: flex;
              flex-wrap: wrap;
              flex-direction: space;
              @include set_theme_color(background-color, menu-tab-bg-color);

              /deep/.step-row {
                position: absolute;
                width: 46px;
                top: -25px;
                display: none;
                right: -45px;
                border-radius: 34px;
                @include set_theme_color(background-color, main-theme-color);

                i {
                  color: #fff;
                  cursor: pointer;
                  @include set_theme_color(background-color, main-theme-color);
                  font-size: 16px;
                  margin: 4px;
                }
              }

              /deep/ .el-steps {
                display: inline-flex;
              }

              .el-step:last-child {
                .step-row {
                  // right: -22px;
                  right: -55px;
                }
              }

              /deep/ .el-step {
                width: 150px;
                height: 160px;
                margin-bottom: 10px;
                @include set_theme_color(background-color, menu-tab-bg-color);

                &:hover {
                  .step-row {
                    display: inherit !important;
                  }
                }
              }

              /deep/ .el-step__head {
                width: 100%;
                position: relative;
              }

              /deep/ .el-step__main {
                width: 150px;
                height: 100%;
                padding: 5px;
                margin: 0 auto;
                word-wrap: break-word;
                -webkit-line-clamp: 2;
                line-clamp: 2;

                //-webkit-box-orient: vertical;
                .is-process {
                  color: #fff !important;
                }

                .el-step__title {
                  color: gray;
                  line-height: 20px;
                  text-align: left;
                  font-size: 12px !important;
                  // height: 40px;
                  // overflow: hidden;
                  // text-overflow: ellipsis;
                  word-wrap: break-word;
                }
              }

              /deep/ .el-step__description {
                margin-top: 3px;
                width: 100px;
                position: relative;
                //align-items: center;
                display: flex;
                flex-flow: column;
              }

              .el-step__description {
                position: relative;
                height: 45px;
                text-align: left;
                word-wrap: break-word;
                margin-left: -37px;
                display: -webkit-box;
              }
            }
          }
        }
      }

      .pagefjDevice {
        width: 100%;
        font-size: 15px;

        .fjTitle {
          display: flex;
          margin-bottom: 12px;
          justify-content: space-between;
          align-items: center;
        }

        .handleDevices {
          padding: 12px;
          @include set_theme_color(background-color, menu-tab-bg-color);
          // width: 100%;
          max-height: 237px;
          flex-flow: wrap;
          display: flex;
          justify-content: left;

          .activeItem {
            .iconClose {
              display: grid !important;
              color: #fff;
            }

            @include set_theme_color(color, active-border-color);
            @include set_theme_color(border-color, active-border-color);
          }

          .handDeviceItem {
            overflow: hidden;
            cursor: pointer;
            width: 100px;
            border: 1px solid #fff;
            margin: 4px;
            height: 75px;
            text-align: center;
            padding: 7px 2px;
            position: relative;

            .deviceContent {
              word-break: break-all;
              display: -webkit-box;
              height: 23px;
              line-height: 23px;
              position: relative;
              font-size: 12px;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            &:hover {
              @include set_theme_color(border-color, active-border-color);

              .iconClose {
                display: grid;
                color: #fff;
              }
            }

            .iconClose {
              @include set_theme_color(background-color, main-theme-color);
              right: 3px;
              position: absolute;
              top: 3px;
              display: none;
              width: 20px;
              border-radius: 50%;
              height: 20px;
              line-height: 22px;
            }
          }
        }
      }

      .left-deviceInfo {
        margin-top: 12px;
        width: 100%;

        .deviceInfo-main {
          padding: 0 0 16px;
          color: #fff;

          // padding: 10px;
          .deviceTitle {
            text-align: left;
            font-size: 15px;

            .icon-transform {
              transform: rotate(180deg);
              transition: all 0.2s;
            }
          }
        }
      }
    }

    .right-box {
      margin-left: 12px;
      @include set_theme_color(background-color, left-menu-bg-color);
    }

    .el-main {
      color: #333;
      text-align: center;
      line-height: 100%;
      padding: 7px 10px;
      margin-right: 100px;

      .wnNum {
        height: 2px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }
  }
}
</style>
